import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 组织机构树-全量加载
  loadMenu(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/loadOrgDataAll', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 部门树-全量加载
  loadDeptDataAll(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/loadDeptDataAll', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 用户退出
  logout(params, callback) {
    return request(API.BASEAPI + 'logout', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构-行政区划全量加载
  getAllAreaInfoTree(params, callback) {
    return request(API.BASEAPI + 'open/area/getAllAreaInfoTree', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 修改密码-根据账号
  updateLoginPwdByLoginName(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/updateLoginPwdByLoginName', 'post', params).then((data) => {
      callback(data);
    });
  },
};